import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { featurePropTypes } from './types';
import MiniControlPanel from './components/MiniControlPanel';
import { useActuatorFeatures } from './hooks/useActuatorFeatures';
import CardControlPanel from './components/CardControlPanel';

const ActuatorControlsType = Object.freeze({
  CARD: 'card',
  MINI: 'mini',
});

const ActuatorControlPanel = ({
  exposes,
  deviceId,
  deviceName,
  gateway,
  readOnly,
  type,
  icon,
  noHeader,
}) => {
  const features = useActuatorFeatures(deviceId, exposes);

  return (
    <Box
      height="100%"
      width="100%"
      sx={{
        '& *': {
          pointerEvents: readOnly && 'none !important',
          cursor: readOnly && 'not-allowed !important',
        },
      }}
    >
      {type === ActuatorControlsType.CARD && (
        <CardControlPanel
          deviceId={deviceId}
          gateway={gateway}
          features={features}
          readOnly={readOnly}
          deviceName={deviceName ?? deviceId}
          icon={icon}
          noHeader={noHeader}
        />
      )}

      {type === ActuatorControlsType.MINI && (
        <MiniControlPanel
          deviceId={deviceId}
          gateway={gateway}
          features={features}
          readOnly={readOnly}
          deviceName={deviceName ?? deviceId}
          icon={icon}
          noHeader={noHeader}
        />
      )}
    </Box>
  );
};

ActuatorControlPanel.defaultProps = {
  type: ActuatorControlsType.CARD,
};

ActuatorControlPanel.propTypes = {
  readOnly: PropTypes.bool,
  noHeader: PropTypes.bool,
  deviceId: PropTypes.string,
  deviceName: PropTypes.string,
  gateway: PropTypes.string,
  icon: PropTypes.string,
  exposes: PropTypes.arrayOf(PropTypes.shape({ feature: featurePropTypes }))
    .isRequired,
  type: PropTypes.oneOf([ActuatorControlsType.CARD, ActuatorControlsType.MINI]),
};

export default ActuatorControlPanel;
